export default __webpack_public_path__ + "static/media/PW.0ce7091e.svg";